/* Azhara viewport video gating
   Videos marked with [data-viewport-video] render with preload="none" + poster.
   The mp4 source is attached from data attributes on first approach
   (data-vp-src-mobile <=720p on small screens, data-vp-src-desktop otherwise),
   play() fires at >=50% visibility, pause() when the video leaves the viewport. */
(function () {
  'use strict';

  if (window.azharaVideoGate) return;

  var MOBILE_MQ = window.matchMedia('(max-width: 767px)');

  function pickSrc(video) {
    var d = video.dataset;
    if (MOBILE_MQ.matches) {
      return d.vpSrcMobile || d.vpSrc || d.vpSrcDesktop || '';
    }
    return d.vpSrcDesktop || d.vpSrc || d.vpSrcMobile || '';
  }

  function attachSrc(video) {
    if (video.dataset.vpLoaded) return;
    var src = pickSrc(video);
    if (src && !video.getAttribute('src') && video.childElementCount === 0) {
      video.src = src;
    }
    video.preload = 'auto';
    video.dataset.vpLoaded = '1';
  }

  var observer = null;
  if ('IntersectionObserver' in window) {
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target;
        if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
          attachSrc(video);
          var p = video.play();
          if (p && typeof p.catch === 'function') p.catch(function () {});
        } else if (!entry.isIntersecting && !video.paused) {
          video.pause();
        }
      });
    }, { threshold: [0, 0.5] });
  }

  var seen = new WeakSet();

  function observe(video) {
    if (seen.has(video)) return;
    seen.add(video);
    if (observer) {
      observer.observe(video);
    } else {
      // No IntersectionObserver support: load and play immediately
      attachSrc(video);
      var p = video.play();
      if (p && typeof p.catch === 'function') p.catch(function () {});
    }
  }

  function scan(root) {
    (root || document).querySelectorAll('video[data-viewport-video]').forEach(observe);
  }

  window.azharaVideoGate = { observe: observe, scan: scan, pickSrc: pickSrc };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }
  document.addEventListener('shopify:section:load', function () { scan(); });
})();
